import Vue from 'vue';
import Map from 'collections/map';
import * as types from '../constants/mutationTypes';

export const actions = {
  requestSensor({ commit }, id) {
    return Vue.http.get(`/api/sensors/${id}`).then((response) => {
      commit(types.SET_SENSOR, { id, item: response.data });
      return response;
    });
  },
  requestSensors({ commit }, options = {}) {
    return Vue.http.get('/api/sensors', options).then((response) => {
      commit(types.SET_SENSORS, response.data);
      return response.data;
    });
  },
  requestCreateSensor({ commit }, data) {
    return Vue.http.post('/api/sensors', data).then((response) => {
      const { id } = response.data;
      commit(types.SET_SENSOR, { id, item: response.data });
      return response.data;
    });
  },
  requestUpdateSensor({ commit }, { id, data }) {
    return Vue.http.patch(`/api/sensors/${id}`, data).then((response) => {
      commit(types.SET_SENSOR, { id, item: response.data });
      return response.data;
    });
  },
  requestRelocateSensor({ commit }, { id, data }) {
    return Vue.http.post(`/api/sensors/${id}/relocate`, data).then((response) => {
      commit(types.SET_SENSOR, { id: response.data.id, item: response.data });
      return response.data;
    });
  },
  requestTransferDevice({ commit }, { id, data }) {
    return Vue.http.post(`/api/sensors/${id}/transfer`, data).then((response) => {
      const { source, destination } = response.data;
      commit(types.SET_SENSOR, { id: source.id, item: source });
      commit(types.SET_SENSOR, { id: destination.id, item: destination });
      return response.data;
    });
  },
  requestDestroySensor({ commit }, id) {
    return Vue.http.delete(`/api/sensors/${id}`).then(() => {
      commit(types.DELETE_SENSOR, id);
    });
  },
  clearSensors({ commit }) {
    commit(types.CLEAR_SENSORS);
  },
  reloadSensor: async function ({ commit }, id) {
    commit(types.START_RELOAD_SENSOR, id);
  },
  onReloadSensorFinished: async function ({ commit }, id) {
    commit(types.STOP_RELOAD_SENSOR, id);
  },
  checkAvailability: async function (_, { id, type }) {
    // 種別を渡すと、その種別固有の利用可否条件も含めて判定される
    // (RatSense なら RatSense 側への実在確認)。
    const response = await Vue.http.get(`/api/sensors/${id}/availability`, { params: { type } });
    return response.data.available;
  },
};

export const mutations = {
  SET_SENSOR(state, { id, item }) {
    state.items = state.items.concat([
      [id, item],
    ]);
  },
  SET_SENSORS(state, items) {
    state.items = new Map(items.map(item => [item.id, item]));
  },
  DELETE_SENSOR(state, id) {
    state.items = state.items.filter(item => item.id !== id);
  },
  CLEAR_SENSORS(state) {
    state.items = new Map();
  },
  START_RELOAD_SENSOR(state, id) {
    state.reloadingSensors = [...state.reloadingSensors, id];
  },
  STOP_RELOAD_SENSOR(state, id) {
    state.reloadingSensors = state.reloadingSensors.filter(reloadingId => reloadingId !== id);
  },
};

// 既存センサーの表示順を維持するため rat_sense は末尾に追加する。
const SENSOR_TYPE_ORDERS = {
  insect_monitor_v2: 0,
  rat_monitor: 1,
  hykecam: 2,
  rat_sense: 3,
};

export const getters = {
  getSensor(state) {
    return id => state.items.get(id);
  },
  getSensors(state) {
    return state.items.sorted((prev, next) => {
      if (prev.type !== next.type) {
        const prevOrder = SENSOR_TYPE_ORDERS[prev.type];
        const nextOrder = SENSOR_TYPE_ORDERS[next.type];
        return prevOrder > nextOrder ? 1 : -1;
      }
      const prevPlace = prev.place ?? '';
      const nextPlace = next.place ?? '';
      if (prevPlace !== nextPlace) {
        return prevPlace > nextPlace ? 1 : -1;
      }
      if (prev.name !== next.name) {
        return prev.name > next.name ? 1 : -1;
      }
      return prev.id > next.id ? 1 : -1;
    });
  },
  shouldReloadSensor(state) {
    return id => state.reloadingSensors.includes(id);
  },
};

export const state = () => ({
  items: new Map(),
  reloadingSensors: [],
});
